module.exports = __webpack_public_path__ + "img/unitProductImage_example.2ce306f1.jpg";